import React, { useEffect, useContext, useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import { geocodeByLatLng } from "react-google-places-autocomplete";
import { Drawer, Radio, TextField } from "@material-ui/core";

import "./index.css";
import { api_call_token } from "../../utils/Network";
import { MainContext } from "../../utils/context";
import MapsPlacesSearch from "../MapsPlacesSearch";
import { isMobiledevice, saveLocalData } from "../../utils/helperFunctions";

function extractFromAdress(components, type) {
  for (var i = 0; i < components.length; i++)
    for (var j = 0; j < components[i].types.length; j++)
      if (components[i].types[j] == type) return components[i].long_name;
  return "";
}

export default function AddressPopup({
  show = false,
  addresses = [],
  onClose,
  onSuccess,
  updateAddress = {},
}) {
  const { userData } = useContext(MainContext);
  const [addNewAddress, setAddNewAddress] = useState(
    addresses.length > 0 ? false : true
  );
  const [confirmAddress, setConfirmAddress] = useState(
    updateAddress.address_id ? true : false
  );
  const [latLng, setLatLng] = useState({});
  const [address, setAddress] = useState(
    addresses.length > 0
      ? addresses[0]
      : updateAddress.address_id
      ? { ...updateAddress }
      : {}
  );
  const [error, setError] = useState(false);

  if (!show) return <></>;

  const currentLocationHandler = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          geocodeByLatLng({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          })
            .then((re) => re.length > 0 && parseAddressHandler(re[0]))
            .catch((e) => console.log(e));
          setLatLng({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        function (error) {
          console.error("Error Code = " + error.code + " - " + error.message);
        }
      );
    } else {
      console.log("Not Available");
    }
  };

  const parseAddressHandler = (result = {}) => {
    const city = extractFromAdress(result.address_components, "locality");
    const pincode = extractFromAdress(result.address_components, "postal_code");
    const state = extractFromAdress(
      result.address_components,
      "administrative_area_level_1"
    );
    userData.id
      ? setAddress({
          city,
          pincode,
          state,
          address1: "",
          address2: result.formatted_address.slice(0, 99),
          addressName: result.formatted_address.slice(0, 9),
        })
      : setAddress({
          addressName: result.formatted_address.slice(0, 9),
          address1: result.formatted_address,
        });
  };

  const saveAddressHandler = () => {
    if (address.address1 && userData.id) {
      const payload = {
        user_id: userData?.id,
        ...latLng,
        ...address,
        country: "India",
      };
      if (updateAddress.delete) {
        api_call_token
          .delete(`auth/address/${updateAddress.address_id}/remove_address/`)
          .then((re) => {
            console.log(re);
            onSuccess("Address Deleted Successfully");
          })
          .catch((e) => console.log(e));
      } else if (updateAddress.address_id) {
        api_call_token
          .put(
            `auth/address/${updateAddress.address_id}/edit_address/`,
            payload
          )
          .then((re) => {
            console.log(re);
            onSuccess("Address Updated Successfully");
          })
          .catch((e) => console.log(e));
      } else {
        api_call_token
          .post("auth/address/new_address/", payload)
          .then((re) => {
            // console.log(re);
            saveLocalData("addressName", address.addressName);
            onSuccess("Address Saved Successfully");
          })
          .catch((e) => console.log(e));
      }
    } else {
      saveLocalData("addressName", address.addressName);
      onSuccess("Address Selected Successfully");
    }
  };

  return (
    <>
      <Wrapper show={show} onClose={onClose}>
        {!addNewAddress ? (
          <div className="addr_cont_container">
            <h1 style={{ fontSize: 22, marginBottom: 0, textAlign: "center" }}>
              Select Address
            </h1>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                overflowY: "auto",
                maxHeight: "40vh",
              }}
            >
              {addresses.map((adrs, i) => (
                <div key={adrs.address_id} className="cont_ad_detail">
                  <Radio
                    size="small"
                    value={adrs.address_id}
                    onChange={(e, v) => {
                      saveLocalData("addressName", adrs.address1.slice(0, 9));
                      onSuccess("Address Changed Successfully");
                    }}
                    // checked={adrs.address_id === address.address_id}
                  />
                  <span className="adc_head">
                    {userData.complete_name
                      ? userData.complete_name
                      : "Address"}
                  </span>
                  <div>
                    <p className="adc_para">
                      {adrs.address1} {adrs.address2} {adrs.state}
                      <br />
                      {adrs.city + " - " + adrs.pincode}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ textAlign: "center" }}>
              <button
                onClick={() => (setAddress({}), setAddNewAddress(true))}
                style={{ backgroundColor: "#4d3060" }}
                className="save-btn"
              >
                Add New Address
              </button>
            </div>
          </div>
        ) : !confirmAddress ? (
          <div className="address-container">
            <span className="address-header">
              Select your location to continue
            </span>
            <MapsPlacesSearch
              setLatLng={setLatLng}
              locationHandler={parseAddressHandler}
            />
            <GoLocation />{" "}
            <span onClick={currentLocationHandler} className="address-current">
              Select Current Location
            </span>
            <div style={{ marginTop: 12 }}>
              {address.address1} {address.address2}
            </div>
            <button
              style={{
                backgroundColor: address.addressName ? "#4d3060" : "#ddd", // 22ad73
                cursor: address.addressName ? "pointer" : "not-allowed",
              }}
              disabled={!address.addressName}
              onClick={() =>
                userData.id ? setConfirmAddress(true) : saveAddressHandler()
              }
              className="save-btn"
            >
              {userData.id ? "Continue" : "Confirm Location"}
            </button>
          </div>
        ) : !updateAddress.delete ? (
          <div className="save-container">
            <TextField
              id="standard-full-width"
              required
              label="Home / Society / Apartment Name"
              style={{ margin: 8 }}
              placeholder="Ex. 1 / A , Abc"
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
              // helperText="Please enter your address"
              value={address.address1}
              onInput={(e) =>
                setAddress({ ...address, address1: e.target.value })
              }
            />
            <TextField
              id="standard-full-width"
              label="Area / Landmark / Street Name"
              style={{ margin: 8 }}
              placeholder="Ex. Abc Street"
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
              value={address.address2}
              onInput={(e) =>
                setAddress({ ...address, address2: e.target.value })
              }
            />
            <div style={{ display: "flex" }}>
              <TextField
                id="standard-full-width"
                label="City"
                style={{ margin: 8 }}
                placeholder="Ex. Mumbai"
                required
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                value={address.city}
                onInput={(e) =>
                  setAddress({ ...address, city: e.target.value })
                }
              />
              <TextField
                id="standard-full-width"
                label="State"
                style={{ margin: 8 }}
                placeholder="Ex. Maharashtra"
                // fullWidth
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                required
                value={address.state}
                onInput={(e) =>
                  setAddress({ ...address, state: e.target.value })
                }
              />
              <TextField
                id="standard-full-width"
                label="Pincode"
                style={{ margin: 8 }}
                placeholder="Ex. 400001"
                margin="normal"
                InputLabelProps={{ shrink: true }}
                error={error}
                helperText={error && "Invalid Pincode"}
                required
                value={address.pincode}
                onInput={(e) => {
                  if (/^(\d{4}|\d{6})$/.test(e.target.value)) setError(false);
                  else setError(true);
                  setAddress({ ...address, pincode: e.target.value });
                }}
              />
            </div>
            <button
              style={{
                backgroundColor:
                  address.address1 && !error ? "#4d3060" : "#ddd",
                cursor: address.address1 && !error ? "pointer" : "not-allowed",
              }}
              disabled={!address.address1 || error}
              onClick={saveAddressHandler}
              className="save-btn"
            >
              {updateAddress.address_id ? "Update" : "Save"} Address
            </button>
          </div>
        ) : (
          <div className="address-container">
            <span className="address-header">
              Are you sure to delete the address ?
            </span>
            <div style={{ marginTop: 12, fontSize: 14, textAlign: "justify" }}>
              {address.address1} {address.address2} {address.state}
              <br />
              {address.city + " - " + address.pincode}
            </div>
            <div style={{ textAlign: "center" }}>
              <button
                onClick={saveAddressHandler}
                style={{ backgroundColor: "#4d3060" }}
                className="save-btn"
              >
                Delete Address
              </button>
            </div>
          </div>
        )}
      </Wrapper>
    </>
  );
}

const Wrapper = ({ show, onClose, children }) =>
  isMobiledevice() ? (
    <Drawer
      PaperProps={{
        style: { borderTopRightRadius: 25, borderTopLeftRadius: 25 },
      }}
      open={show}
      onClose={onClose}
      anchor="bottom"
    >
      {children}
    </Drawer>
  ) : (
    <Modal show={show} onClose={onClose}>
      {children}
    </Modal>
  );

const Modal = ({ modalStyle, show, onClose, children, backdropStyle }) => {
  return (
    <React.Fragment>
      {/* onClick={onClose}  */}
      <div style={backdropStyle} className={show ? "modal visible" : "modal"}>
        <div
          style={{
            width: 60,
            height: 40,
            position: "absolute",
            top: 0,
            right: 0,
            margin: "1rem",
            cursor: "pointer",
          }}
          className="close__btn"
        >
          <AiFillCloseCircle onClick={onClose} className="close-icon" />
        </div>
        <div style={modalStyle} className="modal__wrap">
          {children}
        </div>
      </div>
    </React.Fragment>
  );
};
